import React, {useContext } from "react";
import { PJContext } from "./pj-context"
import {supFractions} from "../helpers";



function PJOrderStart(props) {
    const { state, dispatch, data } = useContext(PJContext);

    return  (
        <div className="col-sm-10 offset-sm-1 col-xs-12 offset-xs-0 order-start step-1 box-shadow-bottom">
            <p className={'center subhead'}>You've picked</p>
            <h1 className={'center'} dangerouslySetInnerHTML={{__html: data.title}} />
            <p className={'center'}>What's included:</p>
            <div className={'col-sm-6 offset-sm-3 col-xs-12 highlights'}>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-6  offset-sm-0 col-xs-5 offset-xs-1">
                            {(data.type === 'customBundle') &&
                            <div>
                                {data.included.map((included, i) => {
                                    return (
                                        <div key={i} className="bundle-product" dangerouslySetInnerHTML={{__html: included.title}} />
                                    );
                                })}
                            </div>
                            }
                            {data.highlights.highlights.map((highlight, i) => {
                                return (
                                    <div key={i} className="product-highlight">{highlight}</div>
                                );
                            })}
                        </div>
                        <div className="col-sm-6  offset-sm-0 col-xs-5 offset-xs-0">
                            {data.highlights.common.map((highlight, i) => {
                                return (
                                    <div key={i} className="product-highlight">{highlight}</div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <hr className="has-light-gray-color" />
            </div>
            <p className={"bundle-price center"} dangerouslySetInnerHTML={{__html: supFractions((data.type === 'product') ? data.price : data.bundlePrice)}} />
            {/* On rare occasions (i.e. when two products are in bundle and one of them is Prime Local) the bundle price and regular price will be same. We don't show crossed total price then. */}
            {(data.type !== 'product' && data.price !== data.bundlePrice) &&
            <p className={"regular-price center"}>
                                <span className="price-container">
                                    <span className="full crossed has-light-red-color">&nbsp;</span>
                                    <span className="price"  dangerouslySetInnerHTML={{__html: supFractions(data.price)}} />
                                </span>
            </p>
            }

            <p className={'center'}>per month</p>
            {(data.addons.groups.length > 0|| data.addons.standalone.length > 0) &&
                <p className={'center cta'}><a href={'#select-addons'} className={'arrow-link has-light-red-color'}>Select add-ons</a></p>
            }
        </div>
    );
}

export { PJOrderStart };